module.exports = __webpack_public_path__ + "static/media/56.d261657f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/injectionMoulds/56.jpg
// module id = 196
// module chunks = 0